/* ============================================
   KONLLEN Showcase — Scoped JS for Shopify Dawn
   Wrapped in IIFE, only runs if .kl-showcase exists
   Element IDs prefixed with kl- to avoid conflicts
   ============================================ */
(function() {
  'use strict';

  // Only run on pages with the showcase wrapper
  if (!document.querySelector('.kl-showcase')) return;

  document.addEventListener('DOMContentLoaded', function() {

    // ---------- HERO VIDEO INTRO ----------
    function lockBodyScroll() {
      document.documentElement.classList.add('kl-body-locked');
    }
    function unlockBodyScroll() {
      document.documentElement.classList.remove('kl-body-locked');
    }

    var hero = document.querySelector('.kl-showcase .hero[data-hero-video-intro="true"]');
    var heroVideo = hero ? hero.querySelector('video') : null;

    if (hero && heroVideo) {
      var lockScroll = hero.getAttribute('data-hero-lock-scroll') !== 'false';
      var revealDelay = parseInt(hero.getAttribute('data-hero-reveal-delay') || '0', 10);

      hero.classList.add('has-video-intro');
      if (lockScroll) lockBodyScroll();

      function revealHeroContent() {
        if (!hero.classList.contains('video-intro-ended')) {
          heroVideo.pause();
          hero.classList.add('video-intro-ended');
          unlockBodyScroll();
        }
      }

      // Scroll toggle: down → pause + show text, up → resume + hide text
      var scrollSkip = hero.getAttribute('data-hero-scroll-skip') === 'true';
      if (scrollSkip) {
        var toggleThreshold = hero.offsetHeight * 0.10; // 10% of hero height
        var lastScrollY = 0;
        var isContentVisible = false;

        function showContent() {
          if (!isContentVisible) {
            heroVideo.pause();
            hero.classList.add('video-intro-ended');
            isContentVisible = true;
          }
        }

        function hideContent() {
          if (isContentVisible) {
            heroVideo.play().catch(function(){});
            hero.classList.remove('video-intro-ended');
            isContentVisible = false;
          }
        }

        function handleScrollToggle() {
          var scrollY = window.pageYOffset || window.scrollY;
          var heroBottom = hero.offsetTop + hero.offsetHeight;

          // If scrolled past hero entirely, always show content
          if (scrollY > heroBottom - 100) {
            showContent();
            return;
          }

          if (scrollY > toggleThreshold && !isContentVisible) {
            showContent();
          } else if (scrollY <= toggleThreshold && isContentVisible) {
            hideContent();
          }
        }

        window.addEventListener('scroll', handleScrollToggle, { passive: true });
        handleScrollToggle(); // evaluate on load in case page is already scrolled

        // Mobile: real-time swipe detection (scroll events are throttled on touch devices)
        var touchStartY = 0;
        var touchLastY = 0;
        var touchMoved = false;
        var isTouchInHero = false;
        var touchThreshold = Math.min(toggleThreshold, 60); // ~60px swipe feels natural on mobile

        function handleTouchStart(e) {
          touchStartY = e.touches[0].clientY;
          touchLastY = touchStartY;
          touchMoved = false;
          var heroRect = hero.getBoundingClientRect();
          isTouchInHero = touchStartY >= heroRect.top && touchStartY <= heroRect.bottom;
        }

        function handleTouchMove(e) {
          if (!isTouchInHero) return;
          var y = e.touches[0].clientY;
          var dy = touchStartY - y; // positive = scrolling down
          touchLastY = y;
          touchMoved = true;

          // Swipe up (scroll down) past threshold → pause + show content immediately
          if (dy > touchThreshold && !isContentVisible) {
            showContent();
          }
        }

        function handleTouchEnd(e) {
          if (!touchMoved || !isTouchInHero) return;
          var dy = touchStartY - touchLastY;
          var scrollY = window.pageYOffset || window.scrollY;

          // Swipe up (scroll down) → pause + show content
          if (dy > 30 && !isContentVisible) {
            showContent();
          }
          // Swipe down (scroll up) near top → resume + hide content
          else if (dy < -20 && scrollY < toggleThreshold + 50 && isContentVisible) {
            hideContent();
          }
        }

        window.addEventListener('touchstart', handleTouchStart, { passive: true });
        window.addEventListener('touchmove', handleTouchMove, { passive: true });
        window.addEventListener('touchend', handleTouchEnd, { passive: true });
      }

      // Reveal when video naturally ends (only if not looping)
      if (!heroVideo.loop) {
        heroVideo.addEventListener('ended', revealHeroContent);
      }

      // Force reveal after a custom delay (useful for looped videos)
      if (revealDelay > 0) {
        setTimeout(revealHeroContent, revealDelay * 1000);
      }

      // Fallback: if autoplay fails or video stays paused, reveal after 3s
      setTimeout(function() {
        if (heroVideo.paused && !heroVideo.ended) {
          revealHeroContent();
        }
      }, 3000);

      // Also reveal on any error so the page doesn't get stuck
      heroVideo.addEventListener('error', revealHeroContent);
    }

    // ---------- NAVIGATION SCROLL EFFECT ----------
    var nav = document.getElementById('kl-nav');
    var navToggle = document.getElementById('kl-navToggle');
    var navLinks = document.getElementById('kl-navLinks');

    if (!nav) return;

    function updateNav() {
      if (window.scrollY > 60) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();

    // ---------- MOBILE NAV TOGGLE ----------
    if (navToggle) {
      navToggle.addEventListener('click', function() {
        nav.classList.toggle('mobile-open');
      });
    }

    if (navLinks) {
      navLinks.querySelectorAll('a').forEach(function(link) {
        link.addEventListener('click', function() {
          nav.classList.remove('mobile-open');
        });
      });
    }

    // ---------- SCROLL REVEAL ----------
    var revealElements = document.querySelectorAll('.kl-showcase .reveal');

    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    revealElements.forEach(function(el) {
      revealObserver.observe(el);
    });

    // ---------- SERIES CLASSIC POPOVER EDGE ALIGNMENT ----------
    var classicItems = document.querySelectorAll('.kl-showcase #series:not(.series-cards-expanded) .classic-item');

    function updateClassicEdgeClasses() {
      classicItems.forEach(function(item) {
        item.classList.remove('is-left', 'is-right');
        var rect = item.getBoundingClientRect();
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        var threshold = rect.width * 0.45;

        if (rect.left < threshold) {
          item.classList.add('is-left');
        }
        if (viewportWidth - rect.right < threshold) {
          item.classList.add('is-right');
        }
      });
    }

    var classicEdgeResizeTimer;
    function debouncedClassicEdgeUpdate() {
      clearTimeout(classicEdgeResizeTimer);
      classicEdgeResizeTimer = setTimeout(updateClassicEdgeClasses, 120);
    }

    if (classicItems.length) {
      updateClassicEdgeClasses();
      window.addEventListener('resize', debouncedClassicEdgeUpdate, { passive: true });
    }

    // ---------- ACTIVE NAV LINK HIGHLIGHT ----------
    var sections = document.querySelectorAll('.kl-showcase section[id], .kl-showcase div[id]');
    var navAnchors = navLinks ? navLinks.querySelectorAll('a[href^="#"]') : [];

    var sectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var id = entry.target.getAttribute('id');
          navAnchors.forEach(function(a) {
            a.classList.remove('active');
            if (a.getAttribute('href') === '#' + id) {
              a.classList.add('active');
            }
          });
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '-80px 0px -40px 0px'
    });

    sections.forEach(function(section) {
      if (section.id) {
        sectionObserver.observe(section);
      }
    });

    // ---------- SMOOTH SCROLL FOR ANCHOR LINKS ----------
    document.querySelectorAll('.kl-showcase a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          var offset = 80;
          var position = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: position, behavior: 'smooth' });
        }
      });
    });

    // ---------- PARALLAX ON SERIES CARDS ----------
    var seriesCards = document.querySelectorAll('.kl-showcase .series-card-cue');

    function updateParallax() {
      seriesCards.forEach(function(card) {
        var rect = card.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          var center = rect.top + rect.height / 2;
          var viewportCenter = window.innerHeight / 2;
          var offset = (center - viewportCenter) / viewportCenter;
          card.style.transform = 'translateY(' + (offset * -8) + 'px)';
        }
      });
    }

    window.addEventListener('scroll', updateParallax, { passive: true });

    // ---------- PATENT STAT COUNT UP ----------
    var statNums = document.querySelectorAll('.kl-showcase .patent-stat-num');
    var statsAnimated = false;

    var statObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !statsAnimated) {
          statsAnimated = true;
          statNums.forEach(function(num) {
            var target = parseInt(num.getAttribute('data-count'));
            var current = 0;
            var increment = Math.ceil(target / 30);
            var interval = setInterval(function() {
              current += increment;
              if (current >= target) {
                current = target;
                clearInterval(interval);
              }
              num.textContent = current + (current === target && target > 8 ? '+' : '');
            }, 40);
          });
        }
      });
    }, { threshold: 0.5 });

    if (statNums.length > 0) {
      statObserver.observe(statNums[0].closest('.patent-stats'));
    }

  });
})();
